import { get, isObject } from "lodash";
import { ISKOREA_LIST, LOCAL_LIST, OFFICE_LIST, SEX_LIST } from "../constants/EMPLOYEE";
import store from "../store";
import { TOGGLE_SEARCH_EMPLOYEE_POPUP, SET_SELECTED_EMPLOYEE_LIST, SET_PREVIEW_EMPLOYEE, SET_PREVIEW_EMPLOYEE_SUCCESS, SET_EMPLOYEE_DETAIL_SUCCESS, SET_EMPLOYEE_DETAIL } from "../store/employee/actionTypes";

/*---------------
  직원검색
  options = {
    isSingle // 한명만 선택
    title // 제목 변경
    customEmployees // 커스텀 직원 목록
  }
---------------*/
export const searchEmployee = (
  callback,
  defaultEmployees = [],
  options
) => {

  store.dispatch({
    type: TOGGLE_SEARCH_EMPLOYEE_POPUP,
    payload: { callback, ...options },
  });
  store.dispatch({
    type: SET_SELECTED_EMPLOYEE_LIST,
    payload: defaultEmployees,
  });
};

export const employeePreview = (employee, params = {}) => {
  if (isObject(employee)) {
    store.dispatch({
      type: SET_PREVIEW_EMPLOYEE_SUCCESS,
      payload: { employee, params },
    });
  } else {
    store.dispatch({
      type: SET_PREVIEW_EMPLOYEE,
      payload: { employee, params },
    });
  }
};
export const employeeDetailView = (employee, options = {}) => {
  if (isObject(employee)) {
    store.dispatch({
      type: SET_EMPLOYEE_DETAIL_SUCCESS,
      payload: {
        mode: 'detail',
        ...employee,
      },
    });
  } else {
    store.dispatch({
      type: SET_EMPLOYEE_DETAIL,
      payload: { employeeIdx: employee, options }
    });
  }
};


export const getEmployeeForm = (employee = {}) => {
  return {
    name: get(employee, 'name', ''), // 직원이름
    code: get(employee, 'code', ''), // 직원코드
    otherCode: get(employee, 'otherCode', ''), // 타솔루션 직원코드
    sex: String(get(employee, 'sex', SEX_LIST[0].value)), // 성별 1 남자 2 여자
    juminNum: get(employee, 'juminNum', ""), // 주민번호
    mobile: get(employee, 'mobile', ""),
    phone: get(employee, 'phone', ""),// 전화번호
    email: get(employee, 'email', ""),// 이메일
    profileImg: get(employee, 'profileImg', ""), // 프로필 이미지

    addrCode: get(employee, 'addrCode', ""), // 우편번호
    addr1: get(employee, 'addr1', ""),// 주소
    addr2: get(employee, 'addr2', ""),// 상세 주소

    office: String(get(employee, 'office', OFFICE_LIST[0].value)), // 재직여부 0 퇴사, 1 재직


    joinDate: get(employee, 'joinDate', ""), // 입사일
    leaveDate: get(employee, 'leaveDate', ""),// 퇴사일

    local: String(get(employee, 'local', LOCAL_LIST[0].value)),  // 1:내국인 2:외국인
    isKorea: String(get(employee, 'isKorea', ISKOREA_LIST[0].value)),  // 거주 0외국, 1한국



    nationalName: get(employee, 'nationalName', ""),// 국적 국가명 
    nationalCode: get(employee, 'nationalCode', ""),// 국적 국가코드 

    countryName: get(employee, 'countryName', ""),// 거주지 국가명 
    countryCode: get(employee, 'countryCode', ""),// 거주지 국가코드 


    stayCode: get(employee, 'stayCode', ""),// 체류코드 // 미노출
    stayName: get(employee, 'stayName', ""),/// 체류코드 명 // 미노출

    gradeIdx: get(employee, 'gradeIdx', ""),// 직급 인덱스 // 미노출
    roleRange: get(employee, 'roleRange', "ALL"), // 직원 조회 범위
  };
};